import React from 'react';
import { Bell } from 'lucide-react';
import { useUser } from '../../context/UserContext';

const CandidateDashboardHeaderForProfile = ({ user: propUser }) => {
  const { user: userContextData } = useUser();
  
  // Priority: UserContext > props
  const user = userContextData || propUser || {};
  const userName = user?.name || 'Candidate';

  return (
    <header className="mb-8 animate-fade-in transition-all duration-300">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-black">{userName.split(' ')[0]}</h1>
        <div className="flex items-center gap-4">
          <button className="relative p-2 text-gray-600 hover:text-black transition-colors">
            <Bell size={20} />
          </button>
          <div className="w-10 h-10 bg-white border border-gray-200 rounded-full overflow-hidden">
            <img 
              src={user?.avatar || 'https://i.pravatar.cc/150?img=68'} 
              alt={userName}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default CandidateDashboardHeaderForProfile;
